import { useNavigate } from 'react-router';

import { useGetAccountInfo } from 'apps-common/hooks/AccountApi';
import { throwError } from 'apps-common/utils/errorHandler';
import { t } from 'translations';
import { Header, HorizontalLine, Loader } from 'ui';
import { MainContainer } from 'ui/styles/containers';
import { PageSubtitle, PageTitle } from 'ui/styles/text';

import { UpdateEmailForm } from '../../components/AccountManagement/UpdateEmailForm';
import { UpdatePasswordForm } from '../../components/AccountManagement/UpdatePasswordForm';
import { routes } from '../../routes';

export const AccountManagePage = () => {
  const navigate = useNavigate();
  const { data, isFetching: isFetchingAccountInfo, isError, error } = useGetAccountInfo();

  if (isFetchingAccountInfo) {
    return <Loader />;
  }

  if (isError) {
    throwError('errorOnGetAccount', error);
  }

  const SUB_TITLE =
    data?.accountSource === 'legacy'
      ? t('membership_hub_update_account_information_text')
      : t('membership_hub_update_account_information_text_moi_user');

  return (
    <>
      <Header appType="hub" onBackClick={() => navigate(routes.index)} />
      <PageTitle>{t('membership_hub_account_information')}</PageTitle>
      <PageSubtitle data-testid="pageSubtitle">{SUB_TITLE}</PageSubtitle>
      <MainContainer $padding="10px 5px 0 5px">
        {data?.accountSource === 'legacy' && (
          <>
            <UpdatePasswordForm /> <HorizontalLine $margin="30px 0 40px 0" />
          </>
        )}

        <UpdateEmailForm accountSource={data?.accountSource} />
      </MainContainer>
    </>
  );
};
